// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-table-action-index-module__ui-action-content-hYBnsU {
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-table-action-index-module__action-btn-zOKyl2 {
  margin-right: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-action-content": `------packages-components-bot-semi-src-components-ui-table-action-index-module__ui-action-content-hYBnsU`,
	"uiActionContent": `------packages-components-bot-semi-src-components-ui-table-action-index-module__ui-action-content-hYBnsU`,
	"action-btn": `------packages-components-bot-semi-src-components-ui-table-action-index-module__action-btn-zOKyl2`,
	"actionBtn": `------packages-components-bot-semi-src-components-ui-table-action-index-module__action-btn-zOKyl2`
};
export default ___CSS_LOADER_EXPORT___;
